import { textLogo } from "../../constant/import"
import Breadcrumbs from "../home/Breadcrumbs"
import { NavItems } from "./NavItems"

export default ()=>{



    return(<div className="bg-white h-[12vh] px-16 flex justify-between items-center shadow ">
<div className="flex justify-center items-center"> <img className="my-8" width={140} src={textLogo}/> <Breadcrumbs/> </div>

<NavItems/>
    </div>)
}